import { useStore } from '../store/useStore';
import { getBusinessNatureConfig, hasFeature, getTerminology } from '../config/businessNature';
import type { BusinessNature } from '../db/db';
import type { BusinessNatureConfig } from '../config/businessNature';

export function useBusinessNature() {
  const activeCompany = useStore(s => s.activeCompany);
  const nature: BusinessNature = (activeCompany as any)?.businessNature || 'general';
  const config: BusinessNatureConfig = getBusinessNatureConfig(nature);

  return {
    nature,
    config,
    is: (n: BusinessNature) => nature === n,
    has: (feature: keyof BusinessNatureConfig['features']) => hasFeature(nature, feature),
    term: (key: keyof BusinessNatureConfig['terminology']) => getTerminology(nature, key),
  };
}
